import React from 'react';
import Filters from './Filters';
import SearchInput from '../SearchInput/SearchInput';
import { Button } from '../catalyst/button';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import SpinnerIcon from '../icons/Spinner';

export default function JFTableActions(props) {
  const {
    searchText,
    handleSearchTextChange,
    handleCancelSearch,
    filters = [],
    otherActions = null,
    searchPlaceholder,
    onExportClick,
    exportInProgress,
  } = props;

  return (
    <div className="mb-6">
      <div className="flex justify-between mb-4">
        <div>
          {handleSearchTextChange ? (
            <SearchInput
              placeholder={searchPlaceholder}
              value={searchText}
              onChange={handleSearchTextChange}
              onCancelSearch={handleCancelSearch}
            />
          ) : null}
        </div>
        <div className="flex justify-between space-x-4">
          {onExportClick && (
            <Button
              disabled={exportInProgress}
              onClick={onExportClick}
              outline
            >
              {exportInProgress ? (
                <SpinnerIcon className="animate-spin w-5 h-5" />
              ) : (
                <ArrowUpTrayIcon />
              )}
              Export
            </Button>
          )}
          {otherActions}
        </div>
      </div>
      <Filters filters={filters} />
    </div>
  );
}
